import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import './CustomLink.css';

const CustomLink = ({ link, linktext }) => {
  // Default to "#" if link is undefined
  const absoluteLink = link && link.startsWith('/') ? link : `/${link || '#'}`;

  return (
    <Link to={absoluteLink} className='CustomLink'>
      {linktext || 'Default Text'} <FaArrowRight className='CustomLinkIcon' />
    </Link>
  );
};

export default CustomLink;
